import React from 'react';
import { ComboBoxComponent } from './ComboBox';
import { Provider } from './context';
export const ComboBox = (props) => {
    return (React.createElement(Provider, { comboBoxProps: props },
        React.createElement(ComboBoxComponent, null)));
};
